module.exports = __webpack_public_path__ + "img/email.a9bb3fd9.svg";